import React, {Fragment} from "react";
import {Loading} from "./Loading";
import axios from "axios";

import {connect} from "react-redux";
import {createUser, logOutUser, loadStatus} from "../actions/postAction";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import LoadingBar from "react-top-loading-bar";

import Moment from "react-moment";
import moment from "moment";
import "moment-timezone";

import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from "reactstrap";
import {BASE_URL} from "../constant";
import Loader from "react-loader-spinner";
import SimpleReactValidator from "simple-react-validator";
import {endpoints, http} from "../configs/https";

class Tarbiyyat extends React.Component {
    constructor() {
        super();
        this.state = {
            naumubayin: 0,
            attendance: 0,
            tarbiyyati: 0,
            sermon: 0,
            huzur: 0,
            salat: 0,
            quran: 0,
            daiee: 0,
            modal: false,
            isSubmitting: false,
            return_naumubayin: 0,
            return_attendance: 0,
            return_tarbiyyati: 0,
            return_sermon: 0,
            return_huzur: 0,
            return_salat: 0,
            return_quran: 0,
            return_daiee: 0,
            loading: true
        };
        this.toggle = this.toggle.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    componentDidMount() {
        //this.checkStatus();
        document.title = "NOU MUBAYIN - MKAN REPORT";
    }

    handleChange(event) {
        const {name, value} = event.target;
        this.setState({
            [name]: value
        });
    }

    handleSubmit(event) {
        const {month, year, monthName} = this.props.monthYear;
        event.preventDefault();
        Swal.fire({
            title:
                "Are you sure you want to submit your New convert's report for " +
                monthName +
                " " +
                year +
                "?",
            text:
                "You won't be able to revert this after submitting, kindly check all details are accurate.",
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Submit",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33"
        }).then(result => {
            if (result.value) {
                this.setState({
                    isSubmitting: true
                });
                this.LoadingBar.continousStart();
                http
                    .post(
                        endpoints.NEW_CONVERTS,
                        {
                            naumubayin: this.state.naumubayin,
                            attendance: this.state.attendance,
                            tarbiyyati: this.state.tarbiyyati,
                            sermon: this.state.sermon,
                            huzur: this.state.huzur,
                            salat: this.state.salat,
                            quran: this.state.quran,
                            daiee: this.state.daiee,
                            month: month,
                            year: year
                        },
                    )
                    .then(res => {
                        if (res.status !== 201) {
                            const Toast = Swal.mixin({
                                toast: true,
                                position: "top-end",
                                showConfirmButton: false,
                                timer: 3000
                            });
                            Toast.fire({
                                type: "warning",
                                title: "There is an error in your submission, try again"
                            });
                            this.setState({
                                isSubmitting: false
                            });
                            this.LoadingBar.complete();
                        } else {
                            const Toast = Swal.mixin({
                                toast: true,
                                position: "top-end",
                                showConfirmButton: false,
                                timer: 3000
                            });

                            Toast.fire({
                                type: "success",
                                title: "New Convert's report submitted successfully"
                            });

                            this.LoadingBar.complete();
                            this.setState({
                                phone: "",
                                member_at_forty: res.data.khudam_at_40,
                                number_of_khuddam_uniform: 0,
                                returned_uniform: res.data.total_with_uniform,
                                total_atfal: res.data.total_atfal,
                                total_khuddam: res.data.total_khudam,
                                month: res.data.month,
                                submitted_by: res.data.submitted_by,
                                isSubmitting: false,
                                return_naumubayin: res.data.naumubayin,
                                return_attendance: res.data.attendance,
                                return_tarbiyyati: res.data.tarbiyyati,
                                return_sermon: res.data.sermon,
                                return_huzur: res.data.huzur,
                                return_salat: res.data.salat,
                                return_quran: res.data.quran,
                                return_daiee: res.data.daiee,
                                modal: true
                            });
                            this.props.loadStatus(month, year);
                        }
                    })
                    .catch(error => {
                        this.setState({
                            isSubmitting: false
                        });
                        this.LoadingBar.complete();
                        let errorMessage =
                            (typeof error === "string" && error) ||
                            "An error occured, please try again in a moment.";

                        const Toast = Swal.mixin({
                            toast: true,
                            position: "top-end",
                            showConfirmButton: false,
                            timer: 3000
                        });

                        Toast.fire({
                            type: "error",
                            title: errorMessage
                        });
                        // alert(JSON.stringify(error));
                        console.log(errorMessage);
                    });
            }
        });
    }

    render() {
        const {year, monthName} = this.props.monthYear;
        const {data, isFetching} = this.props.status;
        const {isSubmitting} = this.state;
        return (
            <section className="content">
                {isFetching ? (
                    <div>
                        <div className="spinner">
                            <Loader type="ThreeDots" color="#00BFFF" height="40" width="40"/>
                        </div>
                    </div>
                ) : (
                    <div>
                        {!data.new_convert ? (
                            <div>
                                <LoadingBar onRef={ref => (this.LoadingBar = ref)}/>

                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="card">
                                            <div className="card-header card-header-primary">
                                                <h4 className="card-title">
                                                    TARBIYYAT NOU - MUBAIYEEN (TRAINING OF NEW CONVERTS) -{" "}
                                                    {monthName}, {year}
                                                </h4>
                                                <p className="card-category">
                                                    Khuddam who joined the fold of Ahmadiyya less than 3
                                                    years fall into the category of Nau-Mubaiyeen
                                                </p>
                                            </div>
                                            <div className="card-body">
                                                <form onSubmit={this.handleSubmit}>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label className="bmd-label-floating">
                                                                    Number of Nau-Mubaiyeen Khuddam participating
                                                                    in Tarbiyyati class this month
                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    id="naumubayin"
                                                                    name="naumubayin"
                                                                    min="0"
                                                                    onChange={this.handleChange}
                                                                    value={this.state.naumubayin}
                                                                    onChange={this.handleChange}
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label className="bmd-label-floating">
                                                                    Attendance{" "}
                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    id="attendance"
                                                                    name="attendance"
                                                                    autoComplete="off"
                                                                    min="0"
                                                                    value={this.state.attendance}
                                                                    onChange={this.handleChange}
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label className="bmd-label-floating">
                                                                    Number of Nau-Mubaiyeen Majlis Tarbiyyati Camp
                                                                    was organised this month
                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    id="tarbiyyati"
                                                                    name="tarbiyyati"
                                                                    min="0"
                                                                    value={this.state.tarbiyyati}
                                                                    onChange={this.handleChange}
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label className="bmd-label-floating">
                                                                    No. of Nau-Mubaiyeen Khuddam who wrote letters
                                                                    to Huzoor for prayer this month
                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    id="huzur"
                                                                    name="huzur"
                                                                    min="0"
                                                                    value={this.state.huzur}
                                                                    onChange={this.handleChange}
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label className="bmd-label-floating">
                                                                    No. of Nau-Mubaiyeen who observe 5 daily
                                                                    prayers
                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    id="salat"
                                                                    name="salat"
                                                                    min="0"
                                                                    value={this.state.salat}
                                                                    onChange={this.handleChange}
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label className="bmd-label-floating">
                                                                    No. of Nau-Mubaiyeen who recite the Holy Quran
                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    id="quran"
                                                                    name="quran"
                                                                    value={this.state.quran}
                                                                    min="0"
                                                                    onChange={this.handleChange}
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label className="bmd-label-floating">
                                                                    No. of Nau-Mubaiyeen Khuddam who have become
                                                                    Daiee illallah this month
                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    id="daiee"
                                                                    name="daiee"
                                                                    min="0"
                                                                    value={this.state.daiee}
                                                                    onChange={this.handleChange}
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label className="bmd-label-floating">
                                                                    No. of Nau-Mubaiyeen Khuddam who listened to
                                                                    Live Friday Sermon of Huzoor this month
                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    id="sermon"
                                                                    min="0"
                                                                    name="sermon"
                                                                    value={this.state.sermon}
                                                                    onChange={this.handleChange}
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {isSubmitting ? <Loading/> : ""}

                                                    <button
                                                        type="submit"
                                                        className="btn btn-success pull-right"
                                                        disabled={isSubmitting}
                                                    >
                                                        {isSubmitting ? "Loading..." : "Submit"}
                                                    </button>
                                                    <div className="clearfix"/>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    {/* <Button color="danger" onClick={this.toggle}>{this.props.buttonLabel}</Button> */}
                                    <Modal
                                        isOpen={this.state.modal}
                                        toggle={this.toggle}
                                        className={this.props.className}
                                    >
                                        <ModalHeader toggle={this.toggle}>
                                            Report submission status
                                        </ModalHeader>
                                        <ModalBody>
                                            <p>
                                                Submitted By : {this.state.submitted_by}
                                                <br/>
                                                Month :{" "}
                                                {moment()
                                                    .month(this.state.month - 1)
                                                    .format("MMMM")}
                                                <br/>
                                                Date of Submission : <Moment date={this.state.dateof}/>
                                                <br/>
                                                No of Nau-Mubaiyeen participating in Tarbiyyati class:{" "}
                                                {this.state.return_naumubayin}
                                                <br/>
                                                Attendance : {this.state.return_attendance}
                                                <br/>
                                                No of Nau-Mubaiyeen Majlis Tarbiyyati Camp was
                                                organised: {this.state.return_tarbiyyati}
                                                <br/>
                                                No of Nau-Mubaiyeen Khuddam who wrote letters to Huzoor
                                                : {this.state.return_huzur}
                                                <br/>
                                                No. of Nau-Mubaiyeen who observe 5 daily prayers:{" "}
                                                {this.state.return_salat}
                                                <br/>
                                                No. of Nau-Mubaiyeen who recite the Holy Quran:{" "}
                                                {this.state.return_quran}
                                                <br/>
                                                No. of Nau-Mubaiyeen who have become Daiee illallah:{" "}
                                                {this.state.return_daiee}
                                                <br/>
                                                No. of Nau-Mubaiyeen Khuddam who listened to Live Friday
                                                Sermon of Huzoor: {this.state.return_sermon}
                                                <br/>
                                            </p>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button color="primary" onClick={this.toggle}>
                                                Close
                                            </Button>
                                        </ModalFooter>
                                    </Modal>
                                </div>
                            </div>
                        ) : (
                            <div className="d-flex align-items-center">
                                <h2>
                                    You already submitted New Convert report for{" "}
                                    <b>
                                        {monthName}, {year}
                                    </b>
                                </h2>
                            </div>
                        )}
                    </div>
                )}
            </section>
        );
    }
}

Tarbiyyat.propTypes = {
    createUser: PropTypes.func.isRequired,
    logOutUser: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    isLoggedIn: PropTypes.bool.isRequired
};
const mapStateToProps = state => ({
    user: state.person.user,
    isLoggedIn: state.person.isLoggedIn,
    monthYear: state.currentMonth.monthYear,
    status: state.status
});

export default connect(mapStateToProps, {createUser, logOutUser, loadStatus})(Tarbiyyat);
